export class UploadFile{
	public file_name: string;
	public file_size: number;
	public file_type: string;
}